import { render, staticRenderFns } from "./all-profiles-card.vue?vue&type=template&id=790cc408&scoped=true&"
import script from "./all-profiles-card.vue?vue&type=script&lang=js&"
export * from "./all-profiles-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790cc408",
  null
  
)

export default component.exports